import styled from 'styled-components';
import { resetBtn } from 'styled-manila';
import { getColor, spacingUnits, StyleVars } from 'core/utils';

export const ReviewControlsContainer = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;

	> div {
		margin: ${spacingUnits(1/2)} ${spacingUnits(1/4)} 0;
	}

	@media (max-width: ${StyleVars.screenMd}) {
		flex-wrap: wrap;
		width: 100%;
	}
`;

export const ReviewsFilterContainer = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: flex-end;
	margin-top: ${spacingUnits(1)};

	button {
		${resetBtn}
		display: flex;
		align-items: center;
		color: ${getColor("gray")};
		background-color: white;
		border: 1px solid ${getColor("gray3")};
		padding: ${spacingUnits(0.25)} ${spacingUnits(0.75)};
		white-space: nowrap;

		&:hover, &:focus {
			box-shadow: 0px 0px ${spacingUnits(1/2)} 0px rgba(193, 200, 208, 0.50);
			outline: 0;
		}

		.caret {
			border-top-color: black;
			margin-left: 0.5em;
		}
	}
`;
